// ============================================================================
// LA PASTILLE DE FAMILLE d'un événement de la Console — journal, historique d'un client.
//
// ⚠️ LE CRAN `xs` DE LA CHARTE (`BADGE_SIZES.xs` : 19 px, 10 px, graisse 700) : la pastille vit dans une ligne dense. Les
//    mesures se LISENT dans les jetons, jamais recopiées — une pastille réécrite à la main avait 20 px et 10,5 px.
// ⚠️ La couleur est celle de la FAMILLE (`familyTone`), pas un ton de la charte : les familles sont six, les tons de la
//    pastille n'en connaissent ni le violet des données ni le gris de la plateforme sous ces noms.
// ============================================================================
import { BADGE_SIZES, BADGE_WEIGHT } from '@orgazone/ui-tokens';
import { familyLabel, familyTone } from './event-families';

export function FamilyBadge({ family }: { family: string }) {
  const t = familyTone(family);
  const cran = BADGE_SIZES.xs;
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', height: cran.height, padding: `0 ${cran.padH}px`,
      borderRadius: 'var(--r-pill)', background: t.bg, color: t.fg, fontSize: cran.fontSize, fontWeight: BADGE_WEIGHT,
      whiteSpace: 'nowrap', flexShrink: 0,
    }}>{familyLabel(family)}</span>
  );
}
